import { render } from "./ImportantQuestion.vue?vue&type=template&id=5c350594&scoped=true"
import script from "./ImportantQuestion.vue?vue&type=script&lang=js"
export * from "./ImportantQuestion.vue?vue&type=script&lang=js"

import "./ImportantQuestion.vue?vue&type=style&index=0&id=5c350594&scoped=true&lang=css"
import "./ImportantQuestion.vue?vue&type=style&index=1&id=5c350594&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c350594"]])

export default __exports__